export default __webpack_public_path__ + "media/zurb/img/bryan/bryan-new-8b45af4f72ed0d5b676207f29a70c47f.jpeg";